module.exports = __webpack_public_path__ + "img/billing.1f927158.png";